var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSyntheticIndicesNav = function SvgSyntheticIndicesNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33658A",
    d: "M26 0a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m13 10 1-.5-1-3h9L16 15l-1-2.5-1 .5 1 2.5H6L12 7zm-7.5 6.5H15L13 19l1 .5 2-2.5 4 8.5h-9.5l2-3-1-.5-2 3zM23 6.5l4 9h-4v1h4L21 25l-4.5-9z"
  }))));
};

export { SvgSyntheticIndicesNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjMzM2NThBIiBkPSJNMjYgMGE2IDYgMCAwIDEgNiA2djIwYTYgNiAwIDAgMS02IDZINmE2IDYgMCAwIDEtNi02VjZhNiA2IDAgMCAxIDYtNmgyMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJtMTMgMTAgMS0uNS0xLTNoOUwxNiAxNWwtMS0yLjUtMSAuNSAxIDIuNUg2TDEyIDd6bS03LjUgNi41SDE1TDEzIDE5bDEgLjUgMi0yLjUgNCA4LjVoLTkuNWwyLTMtMS0uNS0yIDN6TTIzIDYuNWw0IDloLTR2MWg0TDIxIDI1bC00LjUtOXoiLz48L2c+PC9zdmc+";